module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/particular03-f3f1c327eb8b6b41fd86699e49c86df0.png";